import Vue from "vue";
import Cookies from "js-cookie";
import App from "./App.vue";
import router from "./router";
import vuex from "vuex";
import store from "./store/index.js";
import "babel-polyfill";
import i18n from "./locale"; // internationalization
//ElementUI
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// import '../theme/index.css'; // 修改element ui 主题颜色
// import './assets/css/theme/409EFF/index.css';
// import './assets/css/theme/E62125/index.css';

/**
 * 首页跳转应用模块的时候，不断的点击图标，如果用户没权限，会弹出从上到下排列的很多条相同的错误提示，很影响美观，所以此处对ElementUI的Message重写
 *
 */
// import { Message } from "element-ui";
// // 为了实现Class的私有属性
// const showMessage = Symbol("showMessage");
// // single默认值true
// class DonMessage {
//   success(options, single = true) {
//     this[showMessage]("success", options, single);
//   }
//   warning(options, single = true) {
//     this[showMessage]("warning", options, single);
//   }
//   info(options, single = true) {
//     this[showMessage]("info", options, single);
//   }
//   error(options, single = true) {
//     this[showMessage]("error", options, single);
//   }
//   closeAll() {
//     Message.closeAll();
//   }
//   [showMessage](type, options, single) {
//     if (single) {
//       // 判断是否已存在Message
//       if (document.getElementsByClassName("el-message").length === 0) {
//         Message[type](options);
//       }
//     } else {
//       Message[type](options);
//     }
//   }
// }

// Vue.prototype.$message = new DonMessage();

import { message } from './tools/resetMessage';
Vue.prototype.$message = message;


//   Vue.use(ElementUI);
Vue.use(ElementUI, {
  size: Cookies && Cookies.get ? Cookies.get("size") : "medium", // set element-ui default size
  i18n: (key, value) => i18n.t(key, value),
});
// -----
//视频播放
import videojs from "video.js";
import "video.js/dist/video-js.css";
// import SWF_PATH from 'videojs-swf/dist/video-js.swf';
// videojs.options.flash.swf = SWF_PATH;
Vue.prototype.$videojs = videojs;
// 花椒播放器
import HJPlayer from "hjplayer";
Vue.prototype.$HJPlayer = HJPlayer;

//文件上传uploader
import uploader from "vue-simple-uploader";
Vue.use(uploader);

//emoji表情
import "./assets/css/iconfont.css";
import "./assets/css/emoji-sprite.scss";
import { emoji } from "./emoji/emoji.js";
Vue.prototype.emoji = emoji;

//axios
import axios from "./tools/axios";
Vue.prototype.$ajax = axios;

// 引入global.js
import Global from "./tools/global";
Vue.prototype.$g = Global; // 全局变量

//echarts
import echarts from "echarts";
Vue.prototype.$echarts = echarts;

//把页面导出成pdf格式功能
import htmlToPdf from "./assets/js/htmlToPdf";
Vue.use(htmlToPdf);

// 日历插件
import FullCalendar from "vue-full-calendar";
Vue.use(FullCalendar);

//图片裁剪
import VueCropper from "vue-cropper";
Vue.use(VueCropper);
//图片预览
import ImageViewer from "./components/common/image-viewer.vue";
Vue.component("ImageViewer", ImageViewer);

//swiper轮播图
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
Vue.use(VueAwesomeSwiper);
//(直播)弹幕
import barrage from "vue2-barrage";
Vue.use(barrage);

import common from "./tools/common";
import login from "./tools/checkAuth";

Vue.prototype.BASE_URL = sessionStorage.getItem("host_addr");
Vue.prototype.API_URL = sessionStorage.getItem("host_addr");

require("./../public/css/reset.css");
require("./../public/css/ipng.css");
require("./../public/js/common.js");

// 提交以后禁用按钮一段时间，防止重复提交
Vue.directive("preventReClick", {
  inserted(el, binding) {
    el.addEventListener("click", () => {
      if (!el.disabled) {
        el.classList.add("is-disabled");
        el.disabled = true;
        setTimeout(() => {
          el.disabled = false;
          el.classList.remove("is-disabled");
        }, binding.value || 1000);
      }
    });
  },
});


Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
